var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-items"},[_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t("list.no_items"))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.$t("list.start_adding"))+" "),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/add_items.svg"),"height":"96","alt":""}})])
}]

export { render, staticRenderFns }